import {NgModule} from "@angular/core";
import {Routes, RouterModule} from "@angular/router";
import {UploadComponent} from "./upload.component";
import {IsAdminGuard} from "../../shared/services/is-admin-guard.service";
import {UploadOneFileComponent} from "./upload-file/upload-file.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {PreviousFirmwaresTable} from "./previous-firmwares-table/previous-firmwares-table.component";

const appRoutes: Routes = [
    { path: 'upload', component: UploadComponent, canActivate: [IsAdminGuard]}
];

@NgModule({
    imports: [
        RouterModule.forChild(appRoutes),
        FormsModule,
        ReactiveFormsModule,
        CommonModule
    ],
    declarations: [
        UploadComponent,
        UploadOneFileComponent,
        PreviousFirmwaresTable
    ],
    exports: [
        UploadComponent,
        UploadOneFileComponent,
        PreviousFirmwaresTable
    ]
})
export class UploadModule{}


// WEBPACK FOOTER //
// ./src/app/front/upload/upload.module.ts